import {
  FlightItinerarySlice,
  MyTripsFilter,
  getIsMixedClassByProps,
} from "redmond";

export const UPCOMING = "Upcoming";
export const PAST = "Past trips";
export const VIEW_ALL = "View all";
export const BOOKINGS = "My bookings";
export const WATCHES = "My Watches";
export const NO_TRIPS_FOUND = "No trips found";
export const NO_WATCHED_TRIPS = "You haven't watched any trips";
export const NO_BOOKINGS = "You haven't made any bookings yet";
export const NO_TRIPS = "You have no upcoming trips";
export const DEPARTURE = "Departure";
export const RETURN = "Return";
export const FLIGHT = "Flight";
export const CONFIRMATION = "Confirmation";
export const BOOK_A_FLIGHT = "Book a flight";
export const BOOK_A_HOTEL = "Book a hotel";
export const THE_AIRLINE = "the airline";
export const RENT_A_CAR = "Rent a car";
export const VIEW_DETAILS = "View details";
export const LOADING_TRIPS = "Fetching trips";

export const getTabTitles = (
  tabFilter: MyTripsFilter,
  tripsCounts: {
    [MyTripsFilter.UPCOMING_TRIPS]: number | undefined;
    [MyTripsFilter.CANCELED_TRIPS]: number | undefined;
    [MyTripsFilter.PAST_TRIPS]: number | undefined;
    [MyTripsFilter.TRAVEL_CREDITS]: number | undefined;
    [MyTripsFilter.WATCHED_TRIPS]: number | undefined;
    [MyTripsFilter.TRIPS_WITH_OFFERS]: number | undefined;
  }
) =>
({
  [MyTripsFilter.TRIPS_WITH_OFFERS]: {
    title: `Trips with offers (${tripsCounts[MyTripsFilter.TRIPS_WITH_OFFERS]
      })`,
    subTitle:
      "Items in this list are any trips that have offers available for them.",
  },
  [MyTripsFilter.UPCOMING_TRIPS]: {
    title: `Upcoming trips (${tripsCounts[MyTripsFilter.UPCOMING_TRIPS]})`,
    subTitle:
      "Items in this list are ordered based on the most upcoming departure, check-in, and pickup dates.",
  },
  [MyTripsFilter.WATCHED_TRIPS]: {
    title: `Watched trips (${tripsCounts[MyTripsFilter.WATCHED_TRIPS]})`,
    subTitle:
      "Items in this list are ordered based on the most upcoming departure dates",
  },
  [MyTripsFilter.CANCELED_TRIPS]: {
    title: tripsCounts[MyTripsFilter.CANCELED_TRIPS] !== undefined
      ? `Canceled trips (${tripsCounts[MyTripsFilter.CANCELED_TRIPS]})`
      : "Canceled trips",
    subTitle:
      "Items in this list are trips that have been canceled.",
  },
  [MyTripsFilter.PAST_TRIPS]: {
    title: tripsCounts[MyTripsFilter.PAST_TRIPS] !== undefined
      ? `Past trips (${tripsCounts[MyTripsFilter.PAST_TRIPS]})`
      : "Past trips",
    subTitle:
      "Items in this list are ordered based on the most recent past departure, check-in and pick up dates.",
  },
  [MyTripsFilter.TRAVEL_CREDITS]: {
    title: tripsCounts[MyTripsFilter.TRAVEL_CREDITS] !== undefined
      ? `Airline Travel credits (${tripsCounts[MyTripsFilter.TRAVEL_CREDITS]})`
      : "Airline Travel credits",
    subTitle:
      "Items in this list are ordered based on the most recent original departure dates.",
  },
}[tabFilter]);

// mixed cabin is true if the following conditions are met:
// - fareShelf rating of 3 or above AND one of the below:
//  - the fareShelf shortBrandName is PREMIUM ECONOMY AND one of the segment has a cabinClassName of ECONOMY
//  - the shortBrandName is FIRST or BUSINESS (not premium economy) AND one of the segment includes the word "Economy" (PREMIUM ECONOMY/ECONOMY)
// note: fareShelf checking using the shortBrandName instead of the cabinClassName because the cabinClassName mapping is currently incorrect in same cases (we were getting back a cabinClassName of FIRST instead of PREMIUM ECONOMY)

export const getIsMixedClass = (slice: FlightItinerarySlice): boolean => {
  const { fareShelf } = slice;

  return getIsMixedClassByProps({
    fareShelfRating: fareShelf?.rating,
    fareShelfBrandName: fareShelf?.brandName,
    fareShelfShortBrandName: fareShelf?.shortBrandName,
    cabinClassNames: slice.segments.map((segment) => segment.cabinClassName),
  });
};

export const FAQ_TITLE = "Questions about your trip?";
export const FAQ_CTA = "View FAQs";

export const TRAVEL_SALES_EVENT_ACTIVE_SUBTITLE =
  "Save up to $200 on select hotels with our first-ever travel sale.";
export const TRAVEL_SALES_EVENT_ACTIVE_CTA = "Explore destinations on sale";

export const TRAVEL_SALES_EVENT_LEADUP_SUBTITLE =
  "Our first-ever travel sale lands in";
export const TRAVEL_SALES_EVENT_LEADUP_CTA = "Explore upcoming sale";

export const getActivitiesCrossSellBannerTitle = (location: string) =>
  `Looking for things to do in ${location}?`;
export const ACTIVITIES_CROSS_SELL_BANNER_SUBTITLE =
  "Explore recommended activities for your trip and earn 5X miles on every booking.";
export const ACTIVITIES_CROSS_SELL_BANNER_CTA = "Explore activities";

export const getActivitiesCrossSellOngoingBannerTitle = (location: string) =>
  `Keep exploring ${location}`;
export const ACTIVITIES_CROSS_SELL_ONGOING_BANNER_SUBTITLE =
  "Make the most of your stay—find an activity nearby and earn 5X miles on every booking.";
